import React, { useEffect, useState } from 'react'
import {
  Button,
  createStyles,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  TextField,
  Theme,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'

interface SearchBarProps {
  getBatchOfCompanies
  history
  selectedLanguage
}

export const SearchBar = ({
  getBatchOfCompanies,
  history,
  selectedLanguage,
}: SearchBarProps) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      searchbar: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
      },
      textfield: {
        margin: 0,
        width: 200,
        backgroundColor: 'white',
      },
      button: {
        width: 200,
        borderRadius: '10px',
        backgroundColor: '#1c8033',
        color: 'white',
        variant: 'contained',
        margin: 5,
        fontSize: 15,
        '&:hover': {
          backgroundColor: '#1c8033',
        },
      },
    })
  )
  const classes = useStyles()

  const [searchValue, setSearchValue] = useState('')
  const [searchProperty, setSearchProperty] = useState('name')

  const getLabel = (key) => {
    const labels = {
      name: 'Name',
    }
    return labels[key]
  }

  useEffect(() => {
    let getAllCompanies = async () => {
      getBatchOfCompanies('', 'name', true)
    }
    getAllCompanies()
  }, [])

  return (
    <div className={classes.searchbar}>
      <TextField
        className={classes.textfield}
        size="small"
        name="test"
        id="searchValue"
        label={getLabel(searchProperty)}
        variant="filled"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyPress={(event) => {
          if (event.key === 'Enter') {
            getBatchOfCompanies(searchValue, searchProperty, true)
          }
        }}
      />

      <FormControl variant="filled" size="small">
        <InputLabel htmlFor="outlined-age-native-simple">Suche nach</InputLabel>
        <Select
          className={classes.textfield}
          native
          label={
            {
              de: 'Suche',
              en: 'search',
              fr: 'Suche - FR',
            }[selectedLanguage]
          }
          value={searchProperty}
          onChange={(e) => setSearchProperty(e.target.value as string)}
          inputProps={{
            name: 'searchProperty',
            id: 'searchProperty',
          }}
        >
          <option value="name">Name</option>
        </Select>
      </FormControl>

      <Button
        className={classes.button}
        startIcon={<SearchIcon />}
        onClick={() => getBatchOfCompanies(searchValue, searchProperty, true)}
      >
        {
          {
            de: 'Suchen',
            en: 'search',
            fr: 'Suchen - FR',
          }[selectedLanguage]
        }
      </Button>

      <Button
        className={classes.button}
        onClick={() => history.push(`/createNewCompany`)}
      >
        {
          {
            de: '+ Unternehmen',
            en: '+ Company',
            fr: '+ Unternehmen - FR',
          }[selectedLanguage]
        }
      </Button>
    </div>
  )
}
